import React, {Component} from 'react';

import Registry from '../../../registry/index';

class Snapshot extends Component {

    constructor(props) {
        super(props);

        this.state = {
            snapshotUrl: null
        }
    }

	watchVideo() {
		let {
			user,
			action,
			openVideoWindow
		} = this.props;

		action ? action(openVideoWindow(user.ufrag), 'watch') : openVideoWindow(user.ufrag);
	}

    static getDerivedStateFromProps(nextProps, prevState) {
        let { user } = nextProps;
        let snapshotUrl = user.thumbnail ? user.thumbnail : user.snapshot;

        if (snapshotUrl !== prevState.snapshotUrl) {
            return {
                snapshotUrl: snapshotUrl
            };
        }

        return null;
    }

    render() {
        let { 
        	user, 
        	currentUser, 
        	checkBanned = false
        } = this.props;

        let lang = Registry.get('locale');
        //let snapshotUrl = user.thumbnail ? user.thumbnail : user.snapshot; // Snapshots URLs should be made unique on hitagi side now: ) + "?_=" + Math.floor(Date.now() / 60000);

        user.blocklist instanceof Array ? user.blocklist.map(uid => uid === currentUser.uid ? checkBanned = true : false) : false;

        if((!user.thumbnail && !user.snapshot) || checkBanned) return false;

        return (
        	<a href="#" className="snapshot" onClick={() => this.watchVideo()}>
        		{user.paused ? <div className="paused">{lang.message_video_paused}</div> : null}
                <img src={this.state.snapshotUrl}/>
        	</a>
        );
    }
}

export default Snapshot;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserInfoTooltip/Snapshot.js